module.exports = "<ng-progress #progressBar></ng-progress>\n<router-outlet></router-outlet>\n"